import '../../V1/Javascripts/tabi/top-bar';
import '../../V1/Javascripts/elements/accordion';
import '../../V1/Javascripts/elements/buttons';
import '../../V1/Javascripts/elements/contact-box--reset';
import '../../V1/Javascripts/elements/slider';
import '../../V1/Javascripts/elements/slider-l10n';
import '../../V1/Javascripts/elements/halkaBox';
import '../../V1/Javascripts/elements/line-clamp';
import '../../V1/Javascripts/elements/singleselect';
import '../../V1/Javascripts/elements/datepicker';
import '../../V1/Javascripts/elements/focusarea';
import '../../V1/Javascripts/elements/quicksearch';
import '../../V1/Javascripts/elements/video-autoplay';
import '../../V1/Javascripts/elements/review';
import '../../V1/Javascripts/elements/form-validation';
import '../../V1/Javascripts/elements/typo3-messages';

import { initMainNavBurger } from './elements/_navigation-burger';
import { initMainNav, initServiceNav } from './elements/_navigation-control';
import { initMainNavPosition } from './elements/_navigation-position';
import { initTopbarTitle } from './elements/_topbar--mobile';

function initCustomTabiV15Scripts() {
  initMainNavBurger();
  initServiceNav();
  initMainNav();
  initMainNavPosition();
  initTopbarTitle();
}

if (document.readyState !== 'loading') {
  setTimeout(initCustomTabiV15Scripts);
} else {
  document.addEventListener('DOMContentLoaded', initCustomTabiV15Scripts, { once: true });
}
